import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-39231f74"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "landingpage-background w-screen h-screen" }
const _hoisted_2 = {
  class: "flex flex-col",
  style: {"height":"1020px"}
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-lg md:text-lg" }, " IST-Dämmung ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", { class: "border-bottom" }, [
  /*#__PURE__*/_createElementVNode("th", null, "Bezeichnung"),
  /*#__PURE__*/_createElementVNode("th", null, "Wert")
], -1))
const _hoisted_5 = { class: "border-bottom" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Rohrisolierung", -1))
const _hoisted_7 = { class: "border-bottom" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Armaturenisolierung", -1))
const _hoisted_9 = { class: "border-bottom" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Armaturenisolierung Wasser", -1))
const _hoisted_11 = { class: "border-bottom" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Strangregulierventile", -1))
const _hoisted_13 = { class: "border-bottom" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Anzahl Heizungsstränge", -1))
const _hoisted_15 = { class: "border-bottom" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Anzahl Warmwasserstränge", -1))
const _hoisted_17 = { class: "border-bottom" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Bemerkungen", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_pdf_page_header = _resolveComponent("pdf-page-header")!
  const _component_universal_pdf_image_row = _resolveComponent("universal-pdf-image-row")!
  const _component_pdf_a4_page = _resolveComponent("pdf-a4-page")!

  return (_openBlock(), _createBlock(_component_pdf_a4_page, {
    "no-margin": "",
    "pdf-key": _ctx.lang,
    class: "pdf-content"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_pdf_page_header, {
            immobilie: _ctx.immobilie,
            hzba: _ctx.ba,
            active: _ctx.Test,
            lang: _ctx.lang,
            "crumbs-beginning": 'IST-Einstellparameter > ',
            "crumbs-middle": 'IST-Dämmung',
            "crumbs-end": ' > Optimierungspotenzial > Mängel'
          }, null, 8, ["immobilie", "hzba", "active", "lang"]),
          _hoisted_3,
          _createElementVNode("table", null, [
            _hoisted_4,
            _createElementVNode("tr", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("td", null, _toDisplayString(_ctx.useEnsimimavPdf.getWaermeverteilung(_ctx.ba)['rohrisolierung'] ? _ctx.useEnsimimavPdf.getWaermeverteilung(_ctx.ba)['rohrisolierung'] : "-"), 1)
            ]),
            _createElementVNode("tr", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("td", null, _toDisplayString(_ctx.useEnsimimavPdf.getWaermeverteilung(_ctx.ba)['armaturenisolierung'] ? _ctx.useEnsimimavPdf.getWaermeverteilung(_ctx.ba)['armaturenisolierung'] : "-"), 1)
            ]),
            _createElementVNode("tr", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("td", null, _toDisplayString(_ctx.useEnsimimavPdf.getWaermeverteilung(_ctx.ba)['armaturenisolierung_wasser'] ? _ctx.useEnsimimavPdf.getWaermeverteilung(_ctx.ba)['armaturenisolierung_wasser'] : "-"), 1)
            ]),
            _createElementVNode("tr", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("td", null, _toDisplayString(_ctx.useEnsimimavPdf.getWaermeverteilung(_ctx.ba)['strangregulierventile'] ? _ctx.useEnsimimavPdf.getWaermeverteilung(_ctx.ba)['strangregulierventile'] : "-"), 1)
            ]),
            _createElementVNode("tr", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("td", null, _toDisplayString(_ctx.useEnsimimavPdf.getWaermeverteilung(_ctx.ba)['anzahlheizungsstraenge'] ? _ctx.useEnsimimavPdf.getWaermeverteilung(_ctx.ba)['anzahlheizungsstraenge'] : "-"), 1)
            ]),
            _createElementVNode("tr", _hoisted_15, [
              _hoisted_16,
              _createElementVNode("td", null, _toDisplayString(_ctx.useEnsimimavPdf.getWaermeverteilung(_ctx.ba)['anzahlwarmwassertraenge'] ? _ctx.useEnsimimavPdf.getWaermeverteilung(_ctx.ba)['anzahlwarmwassertraenge'] : "-"), 1)
            ]),
            _createElementVNode("tr", _hoisted_17, [
              _hoisted_18,
              _createElementVNode("td", null, _toDisplayString(_ctx.useEnsimimavPdf.getWaermeverteilung(_ctx.ba)['bemerkungen'] ? _ctx.useEnsimimavPdf.getWaermeverteilung(_ctx.ba)['bemerkungen'] : "-"), 1)
            ])
          ]),
          _createVNode(_component_universal_pdf_image_row, {
            "max-images": 5,
            "hide-titles": true,
            stretch: false,
            "image-objects": [].concat(
            _ctx.useEnsimimavPdf.getWaermeverteilung(_ctx.ba)['rohrisolierung_foto'],
            _ctx.useEnsimimavPdf.getWaermeverteilung(_ctx.ba)['armaturenisolierung_foto'],
            _ctx.useEnsimimavPdf.getWaermeverteilung(_ctx.ba)['armaturenisolierung_wasser_foto'],
            _ctx.useEnsimimavPdf.getWaermeverteilung(_ctx.ba)['strangregulierventile_foto'])
          }, null, 8, ["image-objects"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["pdf-key"]))
}